import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Quote, Star, Tv, BookOpen, Trophy } from "lucide-react";
import PageHeader from "../components/PageHeader";
import useReveal from "../hooks/useReveal";
import { images, navPaths } from "../mock/mock";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

const mIcons = [Tv, BookOpen, Trophy, Star];

export default function ChiSiamo() {
  const { t } = useLang();
  useReveal([t]);
  const a = t.about;
  return (
    <main>
      <Seo
        title="Cos'è MichelChef® | Lo Chef Michele Raccuia e il progetto ALLF"
        description="La storia dello Chef Michele Raccuia e della startup innovativa che porta la cucina gourmet italiana nel mondo con il progetto ALLF."
        path="/chi-siamo"
        image={images.chefsKitchen}
      />
      <PageHeader crumb={a.crumb} eyebrow={a.eyebrow} title={a.title} subtitle={a.subtitle} image={images.chefsKitchen} homeLabel={t.common.home} />

      <section className="py-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="reveal">
            <span className="text-[#17784A] font-semibold text-sm uppercase tracking-wider">{a.storyEyebrow}</span>
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl mt-3 text-[#14110F]">{a.storyTitle}</h2>
            <div className="mt-6 space-y-5 text-[#3B342E]/90 text-lg leading-relaxed">
              {t.home.introP.map((p, i) => <p key={i}>{p}</p>)}
              <p>{a.storyExtra}</p>
            </div>
          </div>
          <div className="reveal reveal-delay-1 relative">
            <img src={images.dish5} alt="" className="rounded-3xl w-full h-[460px] object-cover shadow-2xl" />
            <div className="absolute -bottom-6 -left-4 bg-[#14110F] text-white rounded-2xl p-6 max-w-xs shadow-xl">
              <Quote size={28} className="text-[#22B573]" />
              <p className="mt-3 text-sm leading-relaxed text-white/85">{a.quote}</p>
              <p className="mt-3 text-[#22B573] font-semibold text-sm">{a.founder}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#F3EFE7] py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="reveal text-center max-w-2xl mx-auto">
            <span className="text-[#D8382E] font-semibold text-sm uppercase tracking-wider">{a.pathEyebrow}</span>
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl mt-3 text-[#14110F]">{a.pathTitle}</h2>
          </div>
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {a.milestones.map((m, i) => {
              const Icon = mIcons[i];
              return (
                <div key={i} className={`reveal reveal-delay-${i} bg-white rounded-2xl p-7 shadow-sm border border-black/5 card-lift`}>
                  <div className="flex items-center justify-between">
                    <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#17784A]/10 text-[#17784A]"><Icon size={24} /></span>
                    <span className="font-display font-extrabold text-2xl text-[#D8382E]">{m.year}</span>
                  </div>
                  <h3 className="font-display font-bold text-lg mt-5 text-[#14110F]">{m.title}</h3>
                  <p className="mt-2 text-[#3B342E]/75 text-sm leading-relaxed">{m.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="reveal rounded-[32px] bg-[#14110F] text-white p-10 lg:p-16 flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl">{a.ctaTitle}</h2>
            <p className="mt-4 text-white/70 text-lg">{a.ctaText}</p>
          </div>
          <Link to={navPaths.innovation} className="btn-press inline-flex items-center gap-2 rounded-full bg-[#22B573] text-[#083a24] px-7 py-3.5 font-semibold hover:bg-[#1ba065] shrink-0">
            {a.ctaBtn} <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </main>
  );
}
